export function isOriginValid(
  event: MessageEvent,
  allowedOrigins: string[] = [],
  isDev: boolean = ['development', 'test'].includes(process.env.NODE_ENV ?? ''),
): boolean {
  if (isDev) {
    // In development mode, always return true to bypass origin checks
    return true
  }

  if (!event || !event.origin) {
    return false
  }

  // If allowedOrigins is empty, use the current window's origin
  const validOrigins = [...allowedOrigins, window.location.origin, 'pitcher.com']

  const isValid = validOrigins.includes(event.origin) || validOrigins.some((origin) => event.origin.endsWith(origin))

  if (!isValid) {
    console.warn(
      `The message origin ${event.origin} is not the same as the current origin ${window.location.origin}. Bailing...`,
    )
  }

  return isValid
}
